import { render, staticRenderFns } from "./SpreadViewerSettings.vue?vue&type=template&id=1e17ff2a"
import script from "./SpreadViewerSettings.vue?vue&type=script&lang=js"
export * from "./SpreadViewerSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e17ff2a')) {
      api.createRecord('1e17ff2a', component.options)
    } else {
      api.reload('1e17ff2a', component.options)
    }
    module.hot.accept("./SpreadViewerSettings.vue?vue&type=template&id=1e17ff2a", function () {
      api.rerender('1e17ff2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spread-viewer-options/SpreadViewerSettings.vue"
export default component.exports